import { Tooltip } from '@neo/primitives/tooltip'

interface SubaccountCellProps {
  subAuthId?: string | null
  /** auth_id -> name, from toSubaccountNames() */
  names: Map<string, string>
}

// Table cell for an agent's or run's subaccount tag. Name up front with the auth
// id on hover — the same shape as the "Created By" cell (name shown, email on
// hover), which keeps the column narrow while the id stays reachable for support.
// An unresolvable id (list still loading, or a subaccount beyond the fetched 10k)
// renders the id itself rather than nothing.
export const SubaccountCell = ({ subAuthId, names }: SubaccountCellProps) => {
  if (!subAuthId) return null

  const name = names.get(subAuthId)
  if (!name) {
    return <span className="text-p-400 font-mono">{subAuthId}</span>
  }

  return (
    <Tooltip content={subAuthId}>
      <div className="truncate">{name}</div>
    </Tooltip>
  )
}
